enum ComponentName {
  ADMIN = 'Admin',
  ADMINISTRATION = 'Administration',
  ADMIN_USER = 'AdminUser',
  ADMIN_TENANT = 'AdminTenant',
  ADMIN_GROUP = 'AdminGroup',
  ADMIN_ROLE = 'AdminRole',
  ADMIN_AUDIT_LOG = 'AdminAuditLog',
  LOGIN_AUDIT_LOG = 'LoginAuditLog',
  COMPONENT_AUDIT_LOG = 'ComponentAuditLog',
  EXPORT_IMPORT_AUDIT_LOG = 'ExportImportAuditLog',
  CASE = 'Case',
  ENTITY = 'Entity',
  TRANSACTION = 'Transaction',
  TRANSACTION_VARIABLE = 'TransactionVariable',
  ENRICHMENT = 'Enrichment',
  VELOCITY = 'Velocity',
  STRUCT = 'Struct',
  STRUCT_FIELD = 'StructField',
  CONNECTION = 'Connection',
  LIST = 'List',
  LIST_DATA = 'ListData',
  STREAM = 'Stream',
  STREAM_COLUMN = 'StreamColumn',
  RULE = 'Rule',
  API_VARIABLE = 'ApiVariable',
  VELOCITY_VARIABLE = 'VelocityVariable',
  LIST_VARIABLE = 'ListVariable',
  QUERY_VARIABLE = 'QueryVariable',
  BASIC_VARIABLE = 'BasicVariable',
  ACTION = 'Action',
  CONFIGURATION = 'Configuration',
  SANDBOX = 'Sandbox',
  ACCOUNT = 'Account',
  JOBS = 'Jobs',
  NOTIFICATIONS = 'Notifications',
  DASHBOARD = 'Dashboard',
  WATCHLIST = 'Watchlist',
  CUSTOM_LIST = 'Custom-List',
  WATCHLIST_ALERT = 'Watchlist-Alert',
  GRAPH = 'Graph',
  CHART = 'Chart',
  AI_MODEL = 'Ai-Model',
  TRACKER = 'Tracker',
  POLICY = 'Policy',
  ASSESSMENT = 'Assessment',
  ACH = 'ACH',
}

export default ComponentName;
